import { render } from "./Hero.vue?vue&type=template&id=fdf3812a&scoped=true&bindings={\"showButton\":\"props\",\"onButtonClick\":\"options\"}"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=fdf3812a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fdf3812a"

export default script